<div class="flex flex-row w-full h-[75vh] baselayout-padding baselayout-padding-t items-stretch justify-between">
  <div class="flex flex-col w-[30%] h-full items-center justify-between gap-[3.5rem]">
    <app-card-with-header>
      <div header>
        {{ 'CustomerDetails.CustomerDetails'|translate }}
      </div>
      <div headerActions>
        <i class="pi pi-pen-to-square clickable" (click)="openEditCustomerPage()"></i>
      </div>
      <div>
        <div class="grid grid-rows-3 auto-cols-max gap-x-[1.25rem] items-center">
          <div class="row-start-1 col-start-1">
            <i class="pi pi-envelope"></i>&nbsp;
          </div>
          <div class="row-start-1 col-start-2">
            {{ 'CustomerDetails.EMail'|translate }}
          </div>
          <div class="row-start-1 col-start-3">
            <a [href]="'mailto:'+customer?.eMail"> {{ customer?.eMail }}</a>
          </div>
          <div class="row-start-2 col-start-1">
            <i class="pi pi-phone"></i>
          </div>
          <div class="row-start-2 col-start-2">
            {{ 'CustomerDetails.Phone'|translate }}
          </div>
          <div class="row-start-2 col-start-3">
            <a [href]="'tel:'+customer?.phoneNumber">{{ customer?.phoneNumber }}</a>
          </div>
          <div class="row-start-3 col-start-1">
            <i class="pi pi-home"></i>
          </div>
          <div class="row-start-3 col-start-2">
            {{ 'CustomerDetails.Address'|translate }}
          </div>
          <div class="row-start-3 col-start-3">
            <div>
              {{ customer?.street }}&nbsp;{{ customer?.houseNumber }}
            </div>
            <div>
              {{ customer?.postalCode }}&nbsp;{{ customer?.city }}
            </div>
          </div>
        </div>
      </div>
    </app-card-with-header>

    <app-card-with-header>
      <div header>
        {{ 'CustomerDetails.Notes'|translate }}
      </div>
      <div headerActions>
        <i class="pi pi-pen-to-square clickable" (click)="openEditCustomerPage()"></i>
      </div>
      <div>
        @if (!customer) {
          <p-skeleton width="100%" height="auto"></p-skeleton>
        } @else {
          @if (!customer.notes) {
            <p>{{ 'CustomerDetails.NoNotes'|translate }}</p>
          } @else {
            <p-scroll-panel [style]="{width:'100%',height:'100%'}">
              <div class="whitespace-pre-line textbox" [innerHTML]="customer.notes|safeHtml"></div>
            </p-scroll-panel>
          }
        }
      </div>
    </app-card-with-header>

    <app-card-with-header>
      <div header>
        {{ 'CustomerDetails.NextTreatments'|translate }}
      </div>
      <div>
        @if (!nextTreatments || nextTreatments.length === 0) {
          {{ 'CustomerDetails.NoNextTreatments'|translate }}
        } @else {
          <div class="grid grid-rows-2 auto-cols-max gap-[1.25rem] items-center">
            @for (treatment of nextTreatments; track treatment.id; let i = $index) {
              <div [class]="[`row-start-${i}`,'col-start-1']">
                {{ getDate(treatment.appointmentDate) }} {{ getTime(treatment.appointmentDate) }}
              </div>
              <div [class]="[`row-start-${i}`,'col-start-2','flex','gap-2']">
                <p-button [routerLink]="'../../pet-detail/'+treatment.patientId">
                  <span class="material-icons !text-[1rem]">pets</span>
                </p-button>
                <p-button [routerLink]="'../../treatment-detail/'+treatment.id">
                  <span class="material-icons !text-[1rem]">event</span>
                </p-button>
              </div>
              <div [class]="[`row-start-${i}`,'col-start-3']">
                {{ treatment.ownerFirstName + " " + treatment.ownerLastName + " - " + treatment.patientName }}
              </div>
            }
          </div>
        }
      </div>
    </app-card-with-header>
  </div>
  <div class="flex flex-col w-[25%] h-full">
    <app-attachment-gallery
      class="w-full h-full"
      [pinnedDocuments]="pinnedDocuments"
      [notPinnedDocuments]="notPinnedDocuments"
      [hasDocuments]="true"
      (onPinDocument)="pinDocument($event)"
      (onUnpinDocument)="unpinDocument($event)"
      (onDeleteDocument)="openDeleteDocumentDialog($event)"
      (onViewDocument)="openViewDocumentDialog($event)"
      (onAddDocument)="openAddDocumentDialog($event)"
    ></app-attachment-gallery>
  </div>

  <div class="flex flex-col w-[30%] h-full">
    <app-card-with-header>
      <div header>
        <button pButton pRipple label="{{'CustomerDetails.NewPet'|translate}}" icon="pi pi-plus" size="large"
                [routerLink]="'../../pets/create'" [queryParams]="{customerId:customer?.id}"></button>
      </div>
      <div headerActions>
        @if (this.pets && this.pets.length > 0) {
          <div>
            @if (this.shouldShowBehavior) {
              <div>
                <button pButton pRipple icon="pi pi-eye" (click)="toggleShouldShowBehavior()" size="large"></button>
              </div>
            } @else {
              <div>
                <button pButton pRipple icon="pi pi-eye-slash" (click)="toggleShouldShowBehavior()"
                        size="large"></button>
              </div>
            }
          </div>
        }
      </div>
      <div class="h-full w-full">
        @if (!this.pets || this.pets.length === 0) {
          <p class="pl-[1.25rem] h-full">{{ 'CustomerDetails.NoPets'|translate }}</p>
        } @else {
          <div class="w-full h-full pt-[1.25rem]">
            <app-greedy-scroll-panel>
              <div class="flex flex-col w-full gap-[1.25rem]">
                @for (pet of pets; track pet.id) {
                  <div>
                    <p-card class="petcard" styleClass="card-light" [style]="{padding:'0.625rem'}"
                            [routerLink]="'../../pet-detail/'+pet.id">
                      <div class="flex !flex-row w-full items-center">
                        <fa-icon class="icon-primary p-[1rem]" [icon]="faDog" size="4x"></fa-icon>
                        <div class="flex flex-col ml-[1.25rem]">
                          <div class="petcard-header">{{ pet.nickname }}</div>
                          <div>{{ getGender(pet) }}, {{ getNeuteredStatus(pet) }}</div>
                          <div>{{ 'CustomerDetail.Race'|translate }}: {{ pet.race }}</div>
                          <div>{{ 'CustomerDetail.FirstTreatment'|translate }}
                            : {{ getFirstTreatmentForPet(pet) }}
                          </div>
                          <div>{{ 'CustomerDetail.LastTreatment'|translate }}
                            : {{ getLastTreatmentForPet(pet) }}
                          </div>
                        </div>
                        <div class="flex flex-col flex-grow items-end justify-center w-[2rem] gap-[0.25rem]">
                          @if (shouldShowBehavior) {
                            <span class="bg-red-400 rounded-full w-8 h-8"
                                  [ngClass]="estimateHighDangerClassActive(pet)"></span>
                            <span class="bg-yellow-400 rounded-full w-8 h-8"
                                  [ngClass]="estimateMediumDangerClassActive(pet)"></span>
                            <span class="bg-green-400 rounded-full w-8 h-8"
                                  [ngClass]="estimateLowDangerClassActive(pet)"></span>
                            <span class="bg-pink-400 rounded-full w-8 h-8"
                                  [ngClass]="estimatePerfectlySafeClassActive(pet)"></span>
                          }
                        </div>
                      </div>
                    </p-card>
                  </div>
                }
              </div>
            </app-greedy-scroll-panel>
          </div>

        }
      </div>
    </app-card-with-header>
  </div>
</div>
